export function emitInlineMultiname(state, index) {
    if (state.names.length <= index)
        throw 'Name index out of bounds';
    if (state.noHoistMultiname) {
        return '$names[' + index + ']';
    }
    return 'name' + index;
}
